import StockTransactionsApi from '@/services/shop/StockTransactionsApi'
import type {
  StockTransactionCreatePayload,
  StockTransactionInterface,
  StockTransactionTypeInterface,
  StockTransactionUpdatePayload,
  StockTransactionVariantInterface,
  VariantStockInterface,
} from './StockTransaction.types'

export {
  StockTransactionCreatePayload,
  StockTransactionInterface,
  StockTransactionTypeInterface,
  StockTransactionUpdatePayload,
  StockTransactionVariantInterface,
  VariantStockInterface,
}

export class StockTransactionTypeDTO implements StockTransactionTypeInterface {
  id = ''
  name = ''
  l10n_name_key = ''
  description = ''
  l10n_description_key = ''
  user_managed = false
  code = ''
  created_at = ''
  updated_at = ''
}

export class VariantStockDTO implements VariantStockInterface {
  id = ''
  arena_variant_id = ''
  available = 0
  waste = 0
  created_at = ''
  updated_at = ''
}

export class StockTransactionVariantDTO
  implements StockTransactionVariantInterface
{
  id = ''
  arena_product_id = ''
  name = ''
  image = ''
  sku = ''
  created_at = ''
  updated_at = ''
  deleted_at = ''
  stock: VariantStockInterface = new VariantStockDTO()
}

export class StockTransactionDTO implements StockTransactionInterface {
  id = 0
  arena_id = 0
  arena_variant_id = ''
  user_id = 0
  type_id = ''
  supplier_id = ''
  invoice_id = ''
  description = ''
  files: string[] = []
  available_stock_before = 0
  available_stock_after = 0
  waste_stock_before = 0
  waste_stock_after = 0
  created_at = ''
  updated_at = ''
  arena_variant: StockTransactionVariantInterface =
    new StockTransactionVariantDTO()
  type: StockTransactionTypeInterface = new StockTransactionTypeDTO()
}

export default class StockTransaction extends StockTransactionDTO {
  static api = StockTransactionsApi

  constructor(DTO: StockTransactionDTO) {
    super()
    Object.assign(this, DTO)
  }
}
